import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import {
  Col,
  ControlLabel,
  FormControl,
  HelpBlock,
  InputGroup,
  Panel,
  Row,
} from 'react-bootstrap'

import { FormGroup } from 'internal-components/src/components/Form'
import Icon from 'internal-components/src/components/Icon'
import Password from 'internal-components/src/components/Form/Password'
import { ProductRecord, SignupRecord } from 'internal-components/src/records'

import RealmSelector from './RealmSelector'
import PasswordSecurity from '../PasswordSecurity'

export default function AuthenticationDetails({
  errors,
  product,
  requirement,
  setData,
  setServicePassword,
  showUsername = true,
  signup,
}) {
  const needsRealms =
    (requirement.get('realms') && requirement.get('realms').size) ||
    signup.getIn(['data', 'auth.realm'])

  const usernameControl = (
    <FormControl
      onChange={e => setData('auth.username', e.target.value.replace(/@infinite\.net\.au$/, ''))}
      placeholder="Username"
      type="text"
      value={signup.getIn(['data', 'auth.username']) || ''}
    />
  )

  return (
    <div className="authentication-details">
      <h4>Authentication</h4>

      <Row>
        <Col md={4} mdPush={8}>
          {product.addressRequired && (
            <Panel>
              <Panel.Body>
                <h4>Setting up your Equipment</h4>

                <p>
                  You will need these details to set up your equipment for your
                  new service.
                </p>

                <p>
                  Once you have set a password here it cannot be recovered and
                  must be reset by logging into the{' '}
                  <a href="https://portal.infinite.net.au">Customer Portal</a>.
                </p>
              </Panel.Body>
            </Panel>
          )}

          <PasswordSecurity />
        </Col>

        <Col md={8} mdPull={4}>
          {showUsername && (
            <FormGroup
              bsSize="large"
              controlId="serviceUsername"
              errors={errors}
              errorKey={['data[auth.username]', 'data[auth.realm]']}
              feedback={false}
              required
            >
              <ControlLabel>Service Username</ControlLabel>

              {needsRealms && (
                <InputGroup>
                  {usernameControl}
                  <RealmSelector
                    currentRealm={signup.getIn(['data', 'auth.realm']) || ''}
                    realms={requirement.get('realms')}
                    setData={setData}
                  />
                </InputGroup>
              )}
              {!needsRealms && usernameControl}
              <HelpBlock>
                Your username must have at least {requirement.get('usernameValidation') === 'cpanel' ? 8 : 5} characters.
                {signup.getIn(['data', 'auth.realm']) && (
                  <span>
                    {' '}
                    When configuring your equipment remember to include{' '}
                    <span className="text-muted">
                      @{signup.getIn(['data', 'auth.realm'])}
                    </span>{' '}
                    on the end!
                  </span>
                )}
              </HelpBlock>
            </FormGroup>
          )}

          <Password
            bsSize="large"
            controlId="servicePassword"
            controlLabel="Service Password"
            errors={errors}
            hasPassword={signup.get('hasServicePassword')}
            required
            setPassword={setServicePassword}
            showRevealPassword
            value={signup.get('servicePassword') || ''}
          >
            {signup.get('hasServicePassword') && (
              <HelpBlock>
                <Icon name="exclamation-triangle" /> The service password has
                been set previously and cannot be recovered. If you do not know
                what the password is, you can reset this password, which will
                overwrite the previously set password.
                {signup.partner && (
                  <em>
                    {' '}
                    The creator of this signup may have set a password for this
                    signup already, resetting the password here will overwrite
                    what they have provided.
                  </em>
                )}
              </HelpBlock>
            )}
            <HelpBlock>
              Your password must be at least 8 characters. We recommend using a
              password manager to generate and store a strong random password.
            </HelpBlock>
          </Password>
        </Col>
      </Row>
    </div>
  )
}

AuthenticationDetails.propTypes = {
  errors: Ipt.map.isRequired,
  product: Pt.instanceOf(ProductRecord).isRequired,
  requirement: Ipt.record.isRequired,
  setData: Pt.func.isRequired,
  setServicePassword: Pt.func.isRequired,
  showUsername: Pt.bool,
  signup: Pt.instanceOf(SignupRecord).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/ServiceDetail/AuthenticationDetails.jsx